// Set the date we're counting down to
 var countDownDate = new Date("Mar 31, 2024 23:59:59").getTime();

// Update the count down every 1 second
var x = setInterval(function() {
  var now = new Date().getTime();
  var distance = countDownDate - now;

  var days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, "0");
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, "0");
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, "0");
  var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, "0");

  var daysEl = document.getElementById("days");
  var hoursEl = document.getElementById("hours");
  var minutesEl = document.getElementById("minutes");
  var secondsEl = document.getElementById("seconds");
  var countdownEl = document.getElementById("countdown");

  if (daysEl) daysEl.innerHTML = days;
  if (hoursEl) hoursEl.innerHTML = hours;
  if (minutesEl) minutesEl.innerHTML = minutes;
  if (secondsEl) secondsEl.innerHTML = seconds;

  if (distance < 0) {
    clearInterval(x);
    if (countdownEl) countdownEl.innerHTML = "La oferta ha terminado.";
  }
}, 1000);
